export const CO_GET_MATERIALSTANDARD_LISTING = "CO_GET_MATERIALSTANDARD_LISTING"
export const CO_GET_MATERIALSTANDARD_LISTING_SUCCESS = "CO_GET_MATERIALSTANDARD_LISTING_SUCCESS"
export const CO_GET_MATERIALSTANDARD_LISTING_FAILED = "CO_GET_MATERIALSTANDARD_LISTING_FAILED"